export const editorUserIdKey = 'user-id';
export const platformUserIdKey = 'platform-user-id';
export const platformTokenKey = 'platform-token';
